import { render, staticRenderFns } from "./ServRedirectComp.vue?vue&type=template&id=24709406&"
import script from "./ServRedirectComp.vue?vue&type=script&lang=js&"
export * from "./ServRedirectComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports